import cx from "classnames"
import type { ReactNode } from "react"

interface ConversationRowProps {
    tone: "user" | "assistant"
    children: ReactNode
    blockStart?: boolean
    blockEnd?: boolean
}

export function ConversationRow({ tone, children, blockStart = true, blockEnd = true }: ConversationRowProps) {
    return (
        <div className={cx("mx-auto w-full max-w-5xl px-3 sm:px-5", blockStart && "pt-2.5 sm:pt-3", blockEnd && "pb-2.5 sm:pb-3")}>
            <div className={cx("min-w-0", tone === "user" && "border-l-2 border-primary bg-base-200/60 px-3 py-1.5", tone === "assistant" && "py-0.5")}>
                {children}
            </div>
        </div>
    )
}
